<template>
  <div
    class="data-table-server"
    data-testid="data-table-server"
  >
    <NullState
      v-if="showEmptyNullState"
      @new="emit('emptyStateNew')"
      :class="nullStateClass"
      :new-button-title="nullStateNewButtonTitle"
      :on-new="nullStateNewButtonHandler"
      :processing="nullStateProcessing"
      :title="nullStateTitle"
    />
    <v-data-table-server
      v-else
      v-bind="$attrs"
      :class="{ border: border }"
      :headers="translatedHeaders"
      :items-length="tableItemsLength"
      :loading="loading"
      :no-data-text="$bct(noDataText)"
    >
      <template #top>
        <template v-if="$slots.filters">
          <div
            class="ma-3"
            data-testid="data-table-server-top"
          >
            <div class="d-flex flex-column flex-sm-row align-center">
              <div class="w-100 w-auto d-flex flex-wrap ga-2 justify-end justify-sm-start">
                <slot name="filters" />
              </div>
            </div>
          </div>

          <v-divider data-testid="data-table-server-top-divider" />
        </template>
      </template>

      <template
        v-for="(_, name) in $slots"
        #[name]="slotData"
      >
        <slot
          :name="name"
          v-bind="slotData || {}"
        />
      </template>
    </v-data-table-server>
  </div>
</template>

<script setup>
import NullState from '@/shared/components/NullState.vue';

const $bct = inject('translator');
const emit = defineEmits(['emptyStateNew']);

const props = defineProps({
  border: {
    type: Boolean,
    default: false,
  },
  headers: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  noDataText: {
    type: String,
    default: 'No data found',
  },
  nullStateTitle: {
    type: String,
    default: null,
  },
  nullStateNewButtonTitle: {
    type: String,
    default: null,
  },
  nullStateClass: {
    type: String,
    default: 'my-4',
  },
  nullStateProcessing: {
    type: Boolean,
    default: false,
  },
  itemsLength: {
    type: [Number, String],
    default: 0,
  },
});

const nullStateNewButtonHandler = () => {};

defineOptions({
  inheritAttrs: false,
});

const tableItemsLength = computed(() => {
  const raw = props.itemsLength;
  if (raw == null || raw === '') {
    return 0;
  }
  if (typeof raw === 'number') {
    return Number.isFinite(raw) ? raw : 0;
  }
  const parsed = Number.parseInt(String(raw), 10);
  return Number.isFinite(parsed) ? parsed : 0;
});

const showEmptyNullState = computed(() => {
  return Boolean(props.nullStateNewButtonTitle) && tableItemsLength.value === 0 && !props.loading;
});

const translatedHeaders = computed(() => {
  return props.headers.map((header) => {
    const updatedHeader = { ...header };
    if (header.title) {
      updatedHeader.title = $bct(header.title);
    }
    return updatedHeader;
  });
});
</script>
